import styled from "styled-components";
import theme from "../../theme/theme";

const BodyWrapper = styled.div`
  width: 50%;
  @media (max-width: 850px) {
    margin: auto;
  }
  .timeline {
    position: relative;
    margin-top: 50px;
    margin-bottom: 3em;
  }
  .timeline::after {
    content: "";
    position: absolute;
    width: 4px;
    background-color: ${theme.colors.primaryStrong2X};
    top: 0;
    bottom: 0;
    margin-left: -3px;
  }
  /* Container around content */
  .container {
    padding: 0px 10px;
    background-color: inherit;
  }

  /* The circles on the timeline */
  .container:not(:first-child):after {
    content: "";
    position: absolute;
    width: 25px;
    height: 25px;
    background-color: ${theme.colors.primary};
    border-radius: 50%;
    z-index: 1;

    @media (max-width: 850px) {
      display: none;
    }
  }

  .right::after {
    left: -14px;
  }

  .content {
    margin-bottom: 15%;
  }

  .headerText {
    font-size: 32px;
    font-weight: 1000;
    text-transform: uppercase;
    color: ${theme.colors.primaryStrong2X};
  }

  .subContent {
    margin-left: 5%;
  }

  .sectionHeader {
    font-size: 20px;
    font-weight: 700;

    text-transform: uppercase;
    color: ${theme.colors.primaryStrong2X};
  }

  .sectionSubHeader {
    font-size: 20px;
    color: ${theme.colors.primaryStrong2X};
  }
`;

const TimeLine = () => {
  return (
    <BodyWrapper>
      <div className="timeline">
        <div className="container right">
          <div className="content">
            <div className="subContent">
              <div className="headerText">
                <span style={{ color: theme.colors.primary }}>Your</span>
                <br /> Financial Goals In Orbit.
              </div>
            </div>
          </div>
        </div>
        <div class="container right">
          <div class="content">
            <div className="subContent" style={{ width: "100%" }}>
              <div className="sectionHeader">Active + Tactical</div>
              <div className="sectionSubHeader">Strategies</div>
            </div>
          </div>
        </div>
        <div class="container right">
          <div class="content">
            <div className="subContent">
              <div className="sectionHeader">dIGITAL & tRADITIONAL</div>
              <div className="sectionSubHeader">Assets</div>
            </div>
          </div>
        </div>
      </div>
    </BodyWrapper>
  );
};

export default TimeLine;
